// ItemOverride — user-edited override for a specific field of an AI-generated
// item. Per LLM_NATIVE_ARCHITECTURE.md §2.3 (EditableItem) but lightweight:
// instead of wrapping every IngestPackage item in EditableItem<T>, we keep the
// IngestPackage clean (still pure AI output) and store user edits in the
// progress ledger as a separate sparse map keyed by `${itemId}.${field}`.
//
// Why this design:
//   - IngestPackage stays "AI-generated artifact" (clear provenance — §2.1)
//   - User edits live in user-controlled progress (clear ownership)
//   - Revert-to-original is just deleting the override (no history walk)
//   - View's render path: `override.editedText ?? aiItem.field`
//
// Trade-offs vs full EditableItem wrapper:
//   - No edit history (just current vs original) — adequate for v1
//   - Separate IDB keyspace — no IngestPackage migration needed
//   - View must thread the override map; we provide useItemOverride hook
//
// Per陛下 19AP: "EditableItem 加上，我理解这两个东西层级是一样的". This is
// the minimum viable EditableItem落地 — proves the §2.3 pattern works without
// invasive schema changes.
import { z } from 'zod';
export const ItemOverrideSchema = z.object({
    /** Item kind tag — 'mcq' | 'flashcard' | 'essay' | etc. Free-form so future
     *  additions don't need a schema bump. */
    itemKind: z.string().min(1),
    /** Field name on the item being overridden (e.g. 'explanation', 'back'). */
    field: z.string().min(1),
    /** The user's edited text. Markdown allowed (most fields are markdown). */
    editedText: z.string(),
    /** ISO datetime of last edit. */
    editedAt: z.string().datetime(),
    /** Snapshot of the AI-generated original at first edit time. Lets the user
     *  revert without re-fetching IngestPackage. */
    originalSnapshot: z.string(),
}).passthrough();
/** Build the canonical key for itemOverrides map: `${itemId}.${field}`. */
export function overrideKey(itemId, field) {
    return `${itemId}.${field}`;
}
/** Resolve override or fall back to AI original. The view's one-liner. */
export function resolvedField(overrides, itemId, field, aiOriginal) {
    const ov = overrides?.[overrideKey(itemId, field)];
    if (!ov)
        return { text: aiOriginal, isEdited: false, original: aiOriginal };
    return { text: ov.editedText, isEdited: true, original: ov.originalSnapshot };
}
//# sourceMappingURL=item-override.js.map